"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Button = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.primaryLargeButton; });
var PrimaryLargeButton = /** @class */ (function (_super) {
    __extends(PrimaryLargeButton, _super);
    function PrimaryLargeButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrimaryLargeButton.prototype.render = function () {
        return (react_1.default.createElement(Button, { onClick: this.props.onClick, "aria-label": this.props.text, className: this.props.className, disabled: this.props.disabled, "data-automationid": this.props.automationId }, this.props.text));
    };
    PrimaryLargeButton.propTypes = {
        /** Function to call on click */
        onClick: prop_types_1.default.func.isRequired,
        /** Text to display on the button and in the accessiblity info */
        text: prop_types_1.default.string.isRequired,
        /** Disabled */
        disabled: prop_types_1.default.bool,
        /** Id to reference the button by in functional testing */
        automationId: prop_types_1.default.string.isRequired
    };
    PrimaryLargeButton.defaultProps = {
        onClick: function () { },
        text: 'test',
        disabled: false,
        automationId: '',
    };
    return PrimaryLargeButton;
}(react_1.Component));
exports.default = styled_components_1.withTheme(PrimaryLargeButton);
var templateObject_1;
//# sourceMappingURL=PrimaryLargeButton.js.map